import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Share2, Calendar, Gift, TrendingUp } from "lucide-react";

export const ComingSoonBanner = () => {
  return (
    <Card className="border-2 border-dashed border-primary/30 bg-gradient-to-r from-primary/5 to-primary/10">
      <CardContent className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-primary/10">
            <Share2 className="h-6 w-6 text-primary" />
          </div>
          <div className="flex items-center gap-2">
            <h2 className="text-xl font-semibold">Sistema de Indicações</h2>
            <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
              Em Breve
            </Badge>
          </div>
        </div>

        <p className="text-muted-foreground mb-6">
          Prepare-se para expandir sua base de clientes! Em breve você poderá configurar um programa completo de indicações com recompensas automáticas.
        </p>

        <div className="grid md:grid-cols-3 gap-4">
          <div className="flex items-start gap-3">
            <div className="p-1.5 rounded bg-green-100 text-green-600 mt-0.5">
              <Gift className="h-4 w-4" />
            </div>
            <div>
              <h4 className="font-medium text-sm">Recompensas Automáticas</h4>
              <p className="text-xs text-muted-foreground">Configure descontos e bônus para indicados e indicadores</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="p-1.5 rounded bg-blue-100 text-blue-600 mt-0.5">
              <Calendar className="h-4 w-4" />
            </div>
            <div>
              <h4 className="font-medium text-sm">Notificações Inteligentes</h4>
              <p className="text-xs text-muted-foreground">Mensagens automáticas para acompanhar cada indicação</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="p-1.5 rounded bg-purple-100 text-purple-600 mt-0.5">
              <TrendingUp className="h-4 w-4" />
            </div>
            <div>
              <h4 className="font-medium text-sm">Relatórios Detalhados</h4>
              <p className="text-xs text-muted-foreground">Acompanhe o crescimento através das indicações</p>
            </div>
          </div>
        </div>

        <div className="mt-6 p-4 bg-background/50 rounded-lg border">
          <p className="text-sm text-center text-muted-foreground">
            <strong>💡 Prévia das funcionalidades:</strong> Abaixo você pode explorar como serão as configurações do sistema de indicações
          </p>
        </div>
      </CardContent>
    </Card>
  );
};